window.addEventListener('load', function () {
    const links = document.querySelectorAll('a[href="' + window.location.pathname + '"]')
    links.forEach(function (item) {
        item.removeAttribute('href')
    })
})
